<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar :dense="true" >
        <v-toolbar-title> <v-icon>mdi-library-books</v-icon> Claim Accounts List </v-toolbar-title>
        <v-spacer />
        <span class="body-2">Claim No: {{ this.commonInfo.clmNo }}</span>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap>
          <v-flex sm4 xs12>
            <v-subheader class="queryLabel">{{ labels.polNo }}</v-subheader>
            <span class="queryValue">{{ this.commonInfo.polNo }}</span>
          </v-flex>
          <v-flex sm4 xs12>
            <v-subheader class="queryLabel">{{ labels.insuredName }}</v-subheader>
            <span class="queryValue">{{ this.insuredName }}</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text style="height: 400px; overflow-y: auto">
        <v-data-table
          :headers="clmColumns"
          :items="clmAcctList"
          class="elevation-1"
          :loading="loading"
          :server-items-length="totalItems"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          v-bind:options.sync="pagination"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.polNo }}</td>
              <td>{{ row.item.polType }}</td>
              <td>{{ row.item.tranType }}</td>
              <td>{{ row.item.docNo }}</td>
              <td>{{ row.item.curr }}</td>
              <td class="text-right">{{ formatDisplayNumber(row.item.netAmt, 2) }}</td>
              <td class="text-right">{{ formatDisplayNumber(row.item.osBal, 2) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red darken-1" text @click.native="doClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
export default {
  props: {},
  data() {
    return {
      loading: false,
      totalItems: 0,
      pagination: {
        sortDesc: [true],
        page: 1,
        itemsPerPage: 5
      },
      clmColumns: [
        { text: 'Policy No.', align: 'left', value: 'polNo' },
        { text: 'Pol Type', align: 'left', value: 'polType' },
        { text: 'Type', align: 'left', value: 'tranType' },
        { text: 'Doc No.', align: 'left', value: 'docNo' },
        { text: 'Currency', align: 'left', value: 'curr' },
        { text: 'Doc Amount', align: 'right', value: 'netAmt' },
        { text: 'Balance', align: 'right', value: 'osBal' }
      ],
      labels: {
        polNo: 'Policy No.',
        insuredName: 'Insured Name'
      },
      clmAcctList: []
    }
  },
  mounted() {
    this.doFetch()
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    insuredName() {
      var result = ''
      if (this.commonInfo.insdRefNo) {
        result = result + this.commonInfo.insdRefNo + ' - '
      }
      if (this.commonInfo.insdName1) {
        result = result + this.commonInfo.insdName1 + ' '
      }
      if (this.commonInfo.insdName2) {
        result = result + this.commonInfo.insdName2 + ' '
      }
      if (this.commonInfo.insdName3) {
        result = result + this.commonInfo.insdName3 + ' '
      }
      return result
    }
  },
  methods: {
    async doFetch() {
      this.loading = true
      const { page, itemsPerPage } = this.pagination
      const expand = {
        page: page - 1,
        size: itemsPerPage
      }
      const apiUrl = this.$store.state.claims.claimDetail.menu.clmAccts
      if (apiUrl) {
        this.loading = true
        const result = await this.$http.get(
          filterQuery(expandURI(apiUrl, expand), { clmNo: this.commonInfo.clmNo }, this.pagination.sortBy, this.pagination.sortDesc)
        )
        if (result && result.data) {
          const data = result.data
          this.totalItems = data.data.totalItems
          this.clmAcctList = data.data.clmAcctList
        } else {
          this.$toast.error('Unexpected server response')
        }
      } else {
        this.$toast.error('Missing API URL (fetch Claim by Similar Loss Date)')
      }
      this.loading = false
    },
    formatBoolean(value) {
      if (value) {
        return 'Yes'
      }
      return 'No'
    },
    doClose() {
      this.$emit('close')
    },
    formatDisplayNumber(value, scale) {
      return formatDisplayNumber(value, scale)
    },
    formatDisplayDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return ''
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doFetch()
    }
  },
  mixins: [MessageMixin, TableConst.default]
}
</script>

<style>
</style>
